import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faList,
  faMusic,
  faPaperclip,
  faPlay,
  faRetweet,
  faUserCheck,
  faUserPlus,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "antd";
import "./TrackItem.css";
import PlayButton from "../PlayButton/PlayButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setAudioId,
  setAudioLinks,
  setAudioListId,
  setCurrentAudioIndex,
  setPlayState,
  setShowFooter,
  togglePlayPause,
} from "../../Redux/AudioSlice";
import { useNavigate } from "react-router-dom";

function TrackItem({ trackName, artistName, img, ...props }) {
  const {
    handleShowAudioLinks,
    showAudioLinks,
    audioLink,
    trackId,
    trackIndex,
    metadataId,
    audioLinks,
    isFromFooter = false,
    isFromPlaylist = false,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [duration, setDuration] = useState(null);
  const isPlayingSelector = useSelector((state) => state.audio.isPlaying);
  const currentAudioIdSelector = useSelector((state) => state.audio.audioId);
  const audioLinksSelector = useSelector((state) => state.audio.audioLinks);
  const isCurrentTrack = trackId === currentAudioIdSelector;

  useEffect(() => {
    const audio = new Audio(audioLink); // Create instant of audio element
    const handleLoadedMetadata = () => {
      setDuration(audio.duration);
    };
    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    return () => {
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
    };
  }, [audioLink]);

  const formatTime = (time) => {
    if (!time) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handlePlayAudio = () => {
    if (isFromPlaylist && audioLinksSelector.length === 0) {
      dispatch(setShowFooter(true));
      dispatch(setAudioLinks(audioLinks));
      dispatch(setAudioListId(metadataId));
      dispatch(setCurrentAudioIndex(trackIndex));
      dispatch(setAudioId(trackId));
      dispatch(setPlayState(true));
    } else {
      if (isCurrentTrack) {
        dispatch(togglePlayPause());
      } else {
        dispatch(setCurrentAudioIndex(trackIndex));
        dispatch(setAudioId(trackId));
        dispatch(setPlayState(true));
      }
    }
  };

  const handleNavigateTrackDetail = (trackId) => {
    navigate(`/trackDetail/${trackId}`);
  };

  return (
    <>
      <div
        className={`AudioInfoField ${isFromPlaylist && "fromPlaylist"} ${
          !isFromFooter && "fromAudioList"
        } ${isCurrentTrack && "isCurrentAudio"}`}
      >
        <div className="audioInfoAvatarWrapper">
          <img src={img} className="audioInfoAvatar" />
          <PlayButton
            className="audioInfoPlayButton"
            size={isFromPlaylist ? "xs" : "sm"}
            onClick={handlePlayAudio}
            isPlaying={isPlayingSelector && isCurrentTrack}
          />
        </div>
        <div className="AudioDetailInfo">
          <span className="detailInfoArtist" title="artist name">
            {artistName}
          </span>
          <span
            onClick={() => handleNavigateTrackDetail(trackId)}
            className="detailInfoName"
            title="audio name"
          >
            {trackName}
          </span>
        </div>
        <div className="detailInfoBtn">
          {isFromFooter ? (
            <AudioButtons />
          ) : (
            <>
              {isFromPlaylist ? (
                <span className="detailInfoDuration">
                  <FontAwesomeIcon icon={faPlay} /> {"3tr"}
                </span>
              ) : (
                <span className="detailInfoDuration">
                  {formatTime(duration)}
                </span>
              )}
              <AudioButtons
                className="detailBtn"
                isFromPlaylist={isFromPlaylist}
                isFromFooter={false}
              />
            </>
          )}
          {isFromFooter && (
            <Button
              onClick={handleShowAudioLinks}
              shape="circle"
              color="default"
              variant="text"
              title="next up"
            >
              <FontAwesomeIcon
                color={showAudioLinks ? "red" : "black"}
                icon={faList}
              />
            </Button>
          )}
        </div>
      </div>
    </>
  );
}

function AudioButtons({ isLike = false, isFollow = false, ...props }) {
  const {
    toggleLike,
    toggleFollow,
    handleRepost,
    handleCopyLink,
    className,
    isFromFooter = true,
    isFromPlaylist = false,
  } = props;
  return (
    <div className={className}>
      {isFromPlaylist ? (
        <>
          <Button
            shape="circle"
            color="default"
            variant="text"
            title={isLike ? "unlike" : "like"}
            onClick={toggleLike}
          >
            <FontAwesomeIcon color={isLike ? "red" : "black"} icon={faHeart} />
          </Button>
          <Button
            shape="circle"
            color="default"
            variant="text"
            title="repost"
            onClick={handleRepost}
          >
            <FontAwesomeIcon icon={faRetweet} />
          </Button>
          <Button
            shape="circle"
            color="default"
            variant="text"
            title="copy link"
            onClick={handleCopyLink}
          >
            <FontAwesomeIcon icon={faPaperclip} />
          </Button>
        </>
      ) : (
        <>
          <Button
            shape="circle"
            color="default"
            variant="text"
            title={isLike ? "unlike" : "like"}
            onClick={toggleLike}
          >
            <FontAwesomeIcon color={isLike ? "red" : "black"} icon={faHeart} />
          </Button>
          <Button
            shape="circle"
            color="default"
            variant="text"
            title={isFollow ? "unfollow" : "follow"}
            onClick={toggleFollow}
          >
            {isFollow ? (
              <FontAwesomeIcon color="red" icon={faUserCheck} />
            ) : (
              <FontAwesomeIcon color="black" icon={faUserPlus} />
            )}
          </Button>
          {!isFromFooter && (
            <Button
              shape="circle"
              color="default"
              variant="text"
              title="remove from next up"
            >
              <FontAwesomeIcon icon={faXmark} />
            </Button>
          )}
        </>
      )}
    </div>
  );
}

export default TrackItem;
